// Translations for the Calendar page.
const calendarDict = [
  { en: "Calendar", sw: "Kalenda" },
  { en: "Shows events: meetings, trainings, elections. (Placeholder)", sw: "Inaonyesha matukio: mikutano, mafunzo, uchaguzi. (Muundo wa Awali)" },
];

export default calendarDict;
